import React, { useEffect, useRef } from "react";
import { SVG } from "../../../component-configuration/svgs";
import { FaqsQuestionAndAnswer } from "../../../react-components/page-framework/support-nav/faqs-question-answer";
import { Router } from "../../../utilities/router";
import Mailchimp from "react-mailchimp-form";
import Graph from "../images/faq-graph.jpg";

const FAQ = () => {
  const myRef = useRef(null);

  useEffect(() => {
    const currentUrl = window.location.href;
    const scrollTofaq = currentUrl.includes("#:faq");
    if (scrollTofaq) {
      window.scrollTo({ behavior: "smooth", top: myRef.current.offsetTop });
    }
  }, []);

  return (
    <section ref={myRef} className="my-2 px-5" id="faq">
      <h3 className="faqs">FAQs</h3>
      <h3 className="mt-1">We're always looking for ways to make our community better for you.</h3>

      <div className="question-and-answer">
        <FaqsQuestionAndAnswer
          question="What is Radivision?"
          answer={
            <p className="answer">
              Radivision is the Startup Streaming Network connecting millions of viewers to informative and entertaining
              content from and about startups, and sharing the amazing solutions and wealth they’re delivering to the
              world.
              <br />
              <br />
              As a viewer, you can learn about, participate in, and prosper in the changes you want to see in the world
              while creating wealth through private and IPO investment opportunities.
            </p>
          }
        />

        <FaqsQuestionAndAnswer
          question="How big a market is the non-institutional individual investor?"
          answer={
            <p className="answer">
              The Public Markets represent companies that are traded on the public stock exchanges (e.g. the NYSE,
              Nasdaq.) or through other opportunities accessible to the non-institutional “retail”, “consumer”, or “main
              street” investors. Together, these investors have over $80T AUM in the US alone, and another $80T
              globally. 5-20% of these assets represent a potential $20T of new funds engaging in private market and IPO
              investments.
            </p>
          }
        />

        <FaqsQuestionAndAnswer
          question="Why is retail investor support and access to private market and IPO investments needed?"
          answer={
            <p className="answer">
              Prior to 1998, startups used to IPO - i.e have their Initial Public Offering and be listed on one of the
              stock exchanges – in 3-5 years, with much of their growth and profit potential still in the future where
              everyone could have access and growth wealth together.
              <br />
              <br />
              However, after the late 1990s, the financial markets’ infrastructure changed due to several factors (e.g.
              decimalization, electronic trading, hedge fund and large banks’ domination of early- stage venture deals,
              stockbroker disappearance, institutional domination, etc.). Companies had to take longer to grow into
              larger deal sizes to accommodate the large institutions’ demands, and IPOs were delayed to today’s 11-14
              years after founding, with fewer than 1% of venture backed deals IPO-ing.
            </p>
          }
        />

        <FaqsQuestionAndAnswer
          question="Does investing in Private Startups create wealth and positive change?"
          answer={
            <p className="answer">
              The early, high-growth private years delivered 70% higher returns than the public markets, leaving retail
              investors - who typically invest in public market offerings exclusively - far behind economically, driving
              inflation and creating many other critical societal issues. Now, with IPOs delayed up to 14 years, retail
              investors do not have access to the higher ROI (Return on Investment) private investments. Without private
              market access, no matter how hard people work, save, or invest wisely, they can’t create generational
              wealth at the same rate. They are falling into the global wealth gap that has been accelerating since the
              1990s.
              <br />
              <br /> Today, we are in the Entrepreneurial Revolution, where equity is the new money. Radivision is here
              to help everyone understand and participate in this new economy so everyone can grow wealth, more
              investors can contribute to capital formation, and more companies can be funded to deliver innovation and
              positive change to humanity - Everybody wins!
              <br />
              <br />
              You can learn more by visiting the{" "}
              <a
                href="https://blog.radivision.com"
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                  event.preventDefault();
                  const blogInfo = "https://blog.radivision.com";
                  window.open(blogInfo, "_blank");
                }}
              >
                Radivision blog page
              </a>
            </p>
          }
        />
        <FaqsQuestionAndAnswer
          question="How do I invest in a Startup?"
          answer={
            <p className="answer">
              Visit Pitch Planet to view pitch videos and longer episodes from Startups. Dive deeper into the company to
              learn more about their mission, product, fundraising and more. Then, connect directly with the Startup and
              learn about current investment opportunities. It’s that simple.
            </p>
          }
        />

        <FaqsQuestionAndAnswer
          question="How can I learn more about Radivision?"
          answer={
            <p className="answer">
              Learn more on our About Page, where we explain our mission, vision, and values, and where you can watch our 3-minute video with more details.
            </p>
          }
        />
      </div>
      <h3>
        Still have questions or need assistance?{" "}
        <div className="contact-btn">
          <button
            onClick={(e) => {
              e.preventDefault();
              const supportURL = "https://www.radivision.com/support#:contact-us";
              // Router.navigateTo(radivisionURL);
              window.open(supportURL, "_blank");
            }}
            // onClick={() => Router.navigateTo("support", undefined, "contact-us")}
            className="contact"
          >
            Contact Support
          </button>
        </div>
      </h3>
      <div className="signup">
        <h4>
          <strong>Be Empowered!</strong>
        </h4>
        <p>Receive updates from Radivision directly to your inbox.</p>
        {/* <label>
          <input
            type="email"
            // class="form-control bg-transparent rounded-pill col-5 p-4"
            placeholder="Email address ..."
            size={35}
          />
          <button>Sign Me Up!</button>
        </label> */}
        <div id="gettingStartedPanel">
          <Mailchimp
            action="https://radivision.us14.list-manage.com/subscribe/post?u=c735e455810145c521bf76b4d&amp;id=f9c2e477d1"
            fields={[
              {
                name: "EMAIL",
                placeholder: "Email address ...",
                type: "email",
                required: true,
              },
            ]}
            // Change predetermined language
            messages={{
              sending: "Sending...",
              success: "Thank you for subscribing!",
              error: "An unexpected internal error has occurred.",
              empty: "You must write an e-mail.",
              duplicate: "Too many subscribe attempts for this email address",
              button: "Sign me up!",
            }}
            // Add a personalized class
            className="d-inline-flex flex-sm-row flex-column"
          />
        </div>
      </div>
    </section>
  );
};

export default FAQ;
